import { Component } from '@angular/core';

@Component({
  selector: 'tun-duplicate-fine-icon-v5',
  templateUrl: './duplicate-fine-icon-v5.component.html',
  styleUrls: ['./duplicate-fine-icon-v5.component.scss']
})
export class DuplicateFineIconV5Component {

}
